import { boundMethod } from 'autobind-decorator';

class JobsNotificationsContainer {
  loading = false;
  showButton = false;
  buttonText = '';
  showModal = false;
  jobs = [];
  _viewAction = {
    id: 'view',
    label: 'View',
  };
  _dismissAction = {
    id: 'dismiss',
    label: 'Dismiss',
  };
  _subscriptions = [];
  /**
   * @param {ProductFeedsJobsNotifications} productFeedsJobsNotifications To show job notifications.
   * @param {Router}                        router                        To make redirections selected.
   */
  constructor(
    productFeedsJobsNotifications,
    router,
  ) {
    'inject';

    this.buttonActions = [
      this._viewAction,
      this._dismissAction,
    ];

    this._productFeedsJobsNotifications = productFeedsJobsNotifications;
    this._router = router;
  }
  attached() {
    this._subscriptions = [
      this._productFeedsJobsNotifications.onVisibilityChange(this._updateVisibility),
      this._productFeedsJobsNotifications.onJobsUpdate(this._updateJobs),
    ];
    this._productFeedsJobsNotifications.showNotifications();
  }
  detached() {
    this._subscription.forEach((subscription) => subscription.dispose());
  }
  handleButtonAction({ id }) {
    if (id === this._dismissAction.id) {
      this._productFeedsJobsNotifications.dismiss();
    } else if (id === this._viewAction.id && !this.showModal) {
      this.showModal = true;
    }
  }
  onModalClose() {
    this.showModal = false;
  }
  viewJob(job) {
    this.onModalClose();
    this._router.navigateToRoute(
      'productFeeds',
      {
        accountId: job.account.id,
        option: 'jobs',
        itemId: job.id,
      },
    );
  }
  viewJobAccount(job) {
    this.onModalClose();
    this._router.navigateToRoute(
      'productFeeds',
      {
        accountId: job.account.id,
      },
    );
  }
  @boundMethod
  _updateJobs(jobs) {
    this.jobs = jobs;
    if (!jobs.length) {
      this.onModalClose();
      this._productFeedsJobsNotifications.dismiss();
    }
  }
  @boundMethod
  _updateVisibility(show, jobs) {
    if (show !== this.showButton) {
      if (show) {
        this.jobs = jobs;
        this.buttonText = jobs.length === 1 ?
          'There\'s 1 failed job' :
          `There are ${jobs.length} failed jobs`;
      }

      this.showButton = show;
    }
  }
}

export { JobsNotificationsContainer };
